<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GtCUA6/Images/cover.jpg?1684514527813" alt="This image is the cover for the book Una promessa rispettata, Serie Scelta del cuore"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Una promessa rispettata, Serie Scelta del cuore
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Seguito di Legame di Fiducia<br/>Serie Scelta del cuore, Libro 3</i></b></p><p>Jin Rayne si sta ancora abituando ai suoi terrificanti nuovi poteri di pantera nekhene e al suo ruolo di reah della tribù di Logan Church, quando viene a sapere che è stato convocato un sepat: una sfida d’onore. Logan, che non ha mai voluto far altro che guidare la sua piccola tribù, deve andare dall’altra parte del mondo, in Mongolia, e combattere per diventare il più potente leader di pantere mannare del mondo.</p> <p>Logan non sarà l’unico ad affrontare quel viaggio: essendo il suo compagno, Jin deve lottare al suo fianco per onorare il suo impegno verso Logan, la sua cultura e la sua tribù. Ma la prova è lunga e prevede che i due uomini restino separati a lungo: l’umanità di Logan è in gioco. Per superare il terribile sepat, Jin e Logan devono accettare il loro fato, fidarsi l’uno dell’altro, e rispettare le promesse che si sono fatti, costi quel che costi.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Calmes, Cornelia Grey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f2fbe74